export class Category{
	constructor(
		public id: number,
		public categoria: string,
		public id_usuario: number,
		public color: string,
		public valor: string,
		public cliente: number
	){}
}


export class CategoryUsers{
	constructor(
		public id: number,
		public categoria: Array<any>
	){}
}

export class AddUsersProyect{
	constructor(
		public id: number,
		public categoria: Array<any>,
		public proyecto: number
	){}
}

export class Estatus{
	constructor(
		public id: number,
		public importancia: number,
		public num: number
	){}
}

